import { FC, useContext, useMemo } from 'react';
import { RedeliveryContext } from '../redelivery-context';

const RedeliveryDetailReserved: FC<{ id: number }> = ({ id }) => {
  const { redeliveryDetails } = useContext(RedeliveryContext);

  const reserved = useMemo(() => redeliveryDetails.get(id)?.unitCount ?? 0, [id, redeliveryDetails]);

  return (
    <div className="text-field">
      <input className="w-100" type="number" defaultValue={reserved} disabled />
      <label>RESERVED</label>
    </div>
  );
};

export default RedeliveryDetailReserved;
